<su-headline [hidden]="filledForm" h="h1" skin="primary">{{
  headline
}}</su-headline>

<div [style]="descriptionContainerStyle">
  <div
    *ngIf="!filledForm"
    class="sub-headline contactDescription"
    [style]="descriptionStyle"
    [innerHtml]="description | safeHtml"></div>
</div>

<su-card [card]="card" *ngIf="!filledForm">
  <div card-content>
    <div class="button-container">
      <su-button
        skin="primary"
        [label]="'costcenter_change.overview' | translate"
        (onClick)="openCostcenterchangesList()"></su-button>
    </div>
    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"
      (modelChange)="onModelChange($event)">
    </formly-form>
  </div>
</su-card>

<su-headline *ngIf="filledForm" h="h1" skin="primary">{{
  'costcenter_change.title_summary' | translate
}}</su-headline>
<div class="description" *ngIf="filledForm">
  <p
    [innerText]="'costcenter_change.p__info_summary' | translate"
    class="confirm-value"></p>
</div>
<br />
<su-card [card]="cardConfirm" *ngIf="filledForm">
  <div card-content data-debug="form-confirm">
    <ng-container>
      <div class="confirm-container">
        <div>
          <div class="confirm-label">
            <span>
              {{ 'costcenter_change.label__location' | translate }}:
            </span>
          </div>
          <div *ngIf="formModel['searchResult']" class="confirm-value">
            <span class="confirm-value">
              {{ formModel['searchResult'].id }},
            </span>
            <span class="confirm-value">
              {{ formModel['searchResult'].streetName }},
            </span>
            <span class="confirm-value">
              {{ formModel['searchResult'].postalCode }}</span
            >
            <span class="confirm-value">
              {{ formModel['searchResult'].city }}</span
            >
          </div>
          <div *ngIf="!formModel['searchResult']">--</div>
        </div>

        <div *ngIf="!isVb; else billingArea">
          <div class="confirm-label">
            <span>
              {{ 'costcenter_change.label__costcenter' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="costcenterId">
              {{ costcenterId }}
            </span>
            <span class="confirm-value" *ngIf="!costcenterId"> -- </span>
          </div>
        </div>

        <ng-template #billingArea>
          <div>
            <div class="confirm-label">
              <span>
                {{ 'costcenter_change.label__billingArea' | translate }}:
              </span>
            </div>
            <div>
              <span class="confirm-value" *ngIf="formModel['billingArea']">
                {{ formModel['billingArea'] }}
              </span>
              <span class="confirm-value" *ngIf="!formModel['billingArea']">
                --
              </span>
            </div>
          </div>
        </ng-template>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'costcenter_change.label__desiredDate' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['desiredDate']">
              {{ formModel['desiredDate'] | date: 'dd.MM.yyyy' }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['desiredDate']">
              --
            </span>
          </div>
        </div>

        <div>
          <div class="confirm-label">
            <span> {{ 'area_return.label__selected_uses' | translate }}: </span>
          </div>
          <ng-container *ngIf="!isVb; else selectedVbs">
            <div
              *ngIf="(selectedRowsSubject$ | async)?.length > 0; else noData">
              <div
                *ngFor="
                  let usage of selectedRowsSubject$ | async;
                  let i = index
                ">
                <div class="confirm-value">
                  <span>
                    {{ 'area_return.label__room' | translate }}:
                    {{ usage.roomName }}
                  </span>
                  <span *ngIf="usage.workspaceName">
                    <br />
                    {{ 'area_return.label__workSpace' | translate }}:
                    {{ usage.workspaceName }}
                  </span>
                  <span *ngIf="!usage.workspaceName">
                    <br />
                    {{ 'area_return.label__m2' | translate }}:
                    {{ usage.area }} m²
                  </span>
                  <br />
                  <span>
                    {{ 'costcenter_change.label__changeDate' | translate }}:
                    {{
                      isValidDate(usage.usageUntil?.toString()) === true
                        ? (usage.usageUntil | date: 'dd.MM.yyyy')
                        : (formModel['desiredDate'] | date: 'dd.MM.yyyy')
                    }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__validUntil' | translate }}:
                    {{ usage.originalUsageUntil }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__costCenter' | translate }}:
                    {{ usage.costCenter }}
                  </span>
                  <br />
                </div>
                <hr *ngIf="i !== (selectedRowsSubject$ | async)?.length - 1" />
              </div>
            </div>
          </ng-container>
          <ng-template #selectedVbs>
            <div
              *ngIf="(vbSelectedRowsSubject$ | async)?.length > 0; else noData">
              <div
                *ngFor="
                  let usage of vbSelectedRowsSubject$ | async;
                  let i = index
                ">
                <div class="confirm-value">
                  <span>
                    {{ 'costcenter_change.label__changeDate' | translate }}:
                    {{
                      isValidDate(usage.requestedUsageUntil?.toString()) ===
                      true
                        ? (usage.requestedUsageUntil | date: 'dd.MM.yyyy')
                        : (formModel['desiredDate'] | date: 'dd.MM.yyyy')
                    }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__costCenter' | translate }}:
                    {{ usage.costCenterId }}
                  </span>
                  <br />
                  <span>
                    {{
                      'costcenter_change.selected_usages.label__quantity'
                        | translate
                    }}:
                    {{ usage.numberOfWorkspaces }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__validUntil' | translate }}:
                    {{ usage.usageUntil | date: 'dd.MM.yyyy' }}
                  </span>
                  <br />
                </div>
                <hr
                  *ngIf="i !== (vbSelectedRowsSubject$ | async)?.length - 1" />
              </div>
            </div>
          </ng-template>

          <ng-template #noData>
            <span class="confirm-value">--</span>
          </ng-template>
        </div>

        <div>
          <div class="confirm-label">
            <span>
              {{ 'costcenter_change.label__costcenter_new' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['costcenterNew']">
              {{ formModel['costcenterNew']?.searchResult?.costCenter }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['costcenterNew']">
              --
            </span>
          </div>
        </div>
      </div>
    </ng-container>

    <form (ngSubmit)="submit()">
      <div class="confirm-buttons">
        <su-button
          [skin]="'primary'"
          [icon]="'arrow-left'"
          [label]="'ticket.create.confirm.button__back_to_edit' | translate"
          (onClick)="pressBackToEdit()">
        </su-button>
        <su-button
          id="buttonSendInConfirmForm"
          type="submit"
          [skin]="'accent'"
          [icon]="'paper-plane'"
          [label]="'ticket.create.confirm.button__send' | translate"
          [disabled]="isSubmitted">
        </su-button>
      </div>
    </form>
  </div>
</su-card>

<app-cell-templates #sharedTemplates></app-cell-templates>

<ng-container *ngTemplateOutlet="sharedTemplates.selectionCellTemplateRef">
</ng-container>

<ng-template #deleteCellTemplate let-row let-column="column">
  <su-button
    (onClick)="onDeleteSelectedUsage(row, isVb)"
    skin="secondary"
    icon="trash"
    [ariaLabel]="'form.delete' | translate"></su-button>
</ng-template>

<ng-template #datepickerUsageUntilCellTemplate let-row let-column="column">
  <div
    style="
      display: flex;
      justify-content: space-around;
      align-items: baseline;
      margin-top: 10px;
      height: 70px;
    ">
    <mat-form-field style="width: 160px">
      <mat-label>{{ 'area_return.choose_date' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="row.usageUntil"
        (ngModelChange)="onDateChange(row, $event)"
        [min]="minDate"
        [matDatepickerFilter]="dateFilter" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</ng-template>

<ng-template
  #datepickerRequestedUsageUntilCellTemplate
  let-row
  let-column="column">
  <div
    style="
      display: flex;
      justify-content: space-around;
      align-items: baseline;
      margin-top: 10px;
      height: 70px;
    ">
    <mat-form-field style="width: 160px">
      <mat-label>{{ 'area_return.choose_date' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="row.requestedUsageUntil"
        (ngModelChange)="onDateChangeVb(row, $event)"
        [min]="minDate"
        [matDatepickerFilter]="dateFilter" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</ng-template>

<app-spinner-overlay
  [show]="loading"
  [label]="loadingMessage"></app-spinner-overlay>
